import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import domain from "../../../reusecomponent/domain";
import { ErrorToastContainer } from "../../function/CustomFunction";

function MessageLink() {

  const [loading, setLoading] = useState(true);
  const [qrImage, setQrImage] = useState(null);
  const Token = useSelector((state) => state.Token.value);

  // ✅ Auto call when page open
  useEffect(() => {
    createMessageLink();
  }, []);

  const createMessageLink = async () => {

    setLoading(true);

    try {

      const response = await fetch(
        `${domain()}/whatsapp/create-message-link`,
        {
          method: "POST",
          headers: {
            "Authorization": `Bearer ${Token}`,
            "Content-Type": "application/json",
          }
        }
      );

      if (response.status === 201) {

        const blob = await response.blob();
        const imageUrl = URL.createObjectURL(blob);

        setQrImage(imageUrl);

      } else {

        ErrorToastContainer("Failed to create QR");

      }

    } catch (error) {

      console.error(error);
      ErrorToastContainer("Error loading QR");

    }

    setLoading(false);

  };


  // ✅ Download function
  const downloadQR = () => {

    if (!qrImage) return;

    const link = document.createElement("a");
    link.href = qrImage;
    link.download = "whatsapp-message-link-qr.png";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

  };


  return (
    <div className="container mt-4" style={{ maxWidth: '600px' }}>
      <div className="card border-0 shadow-sm p-4 text-center" style={{ borderRadius: '20px', border: '1px solid #e2e8f0', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)' }}>
        <h4 className="fw-bold mb-3" style={{ fontFamily: '"Outfit", sans-serif' }}>Create Message Link</h4>
        
        {loading && (
          <p className="text-muted py-4">Generating QR Code...</p>
        )}

        {!loading && qrImage && (
          <div>
            {/* QR IMAGE */}
            <div className="p-3 bg-white border rounded d-inline-block shadow-sm mb-3" style={{ borderRadius: '15px' }}>
              <img
                src={qrImage}
                alt="WhatsApp QR"
                style={{
                  width: "220px",
                  borderRadius: '10px'
                }}
              />
            </div>

            {/* DOWNLOAD BUTTON */}
            <div>
              <button
                className="btn btn-success px-4 py-2 fw-semibold"
                style={{ backgroundColor: '#075E54', borderColor: '#075E54' }}
                onClick={downloadQR}
              >
                Download QR Code
              </button>
            </div>
          </div>
        )}

        {!loading && !qrImage && (
          <p className="text-danger py-4">QR not available</p>
        )}
      </div>
    </div>
  );

}

export default MessageLink;
